import { Grid } from "@mui/material";
import React, { Component } from "react";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Progress from "../graphs/Progress";
import theme from "../../../styles/customTheme";
import { IconButton } from "@mui/material";
import { Typography } from "@mui/material";
import { Stack } from "@mui/material";
import ShoppingCardIcon from "../../../images/shopping-cart.png";
class BudgetCategoryItem extends Component {
    render() {
        return (
            <Grid container marginTop={3} flexDirection={{ xs: "column", sm: "row" }}>
                <Grid item sm={4}>
                    <Stack direction="row" alignItems={"center"} gap={2}>
                        <img src={this.props?.iconImage ? this.props?.iconImage : ShoppingCardIcon} style={{ width: 45, height: "auto" }} alt=""/>
                        <Stack>
                            <Typography
                                variant="h6"
                                fontWeight="800"
                                color="text.primary"
                            >{this.props.budgetData.name}</Typography>
                            <Typography
                                variant="subtitle2"
                                color="text.secondary"
                                gutterBottom
                            >
                                budget {' '}{this.props.pageisMoney ? '£ ' : null}
                                {this.props.pageisMoney ? this.props.budgetData.budget : this.props.budgetData.budget_co2}
                                {!this.props.pageisMoney ? ' Kg' : null}
                            </Typography>
                        </Stack>
                    </Stack>
                </Grid>
                <Grid item sm={8} display="flex" alignItems="end" direction="row" pl={{ xs: 0, sm: 2, md: 4 }}>
                    <Progress
                        sx={{ flexGrow: 1, marginRight: "1rem" }}
                        width="100%"
                        startText="spent"
                        endText="remaining"
                        startNumber={this.props.showPercentage ?
                            parseFloat((this.props.budgetData.spent_category_pct * 100).toFixed(0)) :
                            this.props.pageisMoney ? parseFloat(this.props.budgetData.spent.toFixed(2)) :
                                parseFloat(this.props.budgetData.spent_co2.toFixed(1))}
                        prefix={this.props.pageisMoney && !this.props.showPercentage ? '£ ' : ' '}
                        suffix={this.props.showPercentage ? '%' : (!this.props.pageisMoney ? ' kg' : null)}
                        endNumber={this.props.showPercentage ? parseFloat((1 - this.props.budgetData.spent_category_pct) * 100).toFixed(0) :
                            this.props.pageisMoney ? parseFloat((this.props.budgetData.budget - this.props.budgetData.spent).toFixed(2)) :
                                parseFloat((this.props.budgetData.budget_co2 - this.props.budgetData.spent_co2).toFixed(1))}
                        color={
                            this.props.showPercentage ?
                                (this.props.budgetData.spent_category_pct > 1 ? theme.palette.error.dark : theme.palette.error.main) :
                                (this.props.pageisMoney) ? (this.props.budgetData.spent > this.props.budgetData.budget) ? theme.palette.error.dark : theme.palette.error.main :
                                    (this.props.budgetData.spent_co2 > this.props.budgetData.budget_co2) ? theme.palette.error.dark : (this.props.budgetData.budget_co2 === 0) ? theme.palette.grey[300] : theme.palette.error.main}

                        showAsPercentage={this.props.showPercentage ? true : false}
                    />

                    <IconButton sx={{
                        flexGrow: 1, minHeight: '3rem', minWidth: "3rem", height: '3rem', width: "3rem", padding: "1rem",
                        marginRight: "-4px", marginLeft: "4px"
                    }} color="primary" aria-label="Open Budget Category" component="div" onClick={this.props.handleBudgetClick}>
                        <ChevronRightIcon />
                    </IconButton>

                </Grid>
            </Grid>

        );
    }
}


export default BudgetCategoryItem;






